<template>
  <div>
    <div class="form-container jlic-israel-shabbaton-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Personal Info:">
            <FormRow v-if="form.currency == 'ILS'" inline class="israeli-tax-id-row">
              <FormCol field="taxId" label="Teudat Zehut" placeholder="Enter your Teudat Zehut" />
            </FormRow>
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <div style=" font-size: 14px; color: #222; padding-top: 3px; padding-bottom: 3px; margin-bottom: 5px;">JLIC Campus/Community you are a part of:</div>
          <FormRow inline>
              <FormCol field="custom.campus" width="half" :showLabel="false">
                <FormSelect>
                  <option :value="null">Select an option</option>
                  <option value="Ariel University">Ariel University</option>
                  <option value="Bar Ilan University / Givat Shmuel">Bar Ilan University / Givat Shmuel</option>
                  <option value="Ben Gurion University / Beer Sheva">Ben Gurion University / Beer Sheva</option>
                  <option value="JLEM">JLEM</option>
                  <option value="Jerusalem College of Technology - Lev">Jerusalem College of Technology - Lev</option>
                  <option value="Jerusalem College of Technology - Tal">Jerusalem College of Technology - Tal</option>
                  <option value="Reichman University / Herzliya">Reichman University / Herzliya</option>
                  <option value="Technion">Technion</option>
                  <option value="Tel Aviv University">Tel Aviv University</option>
                  <option value="Tel Aviv City">Tel Aviv City</option>
                </FormSelect>
                </FormCol>
                <ErrorLabel field="custom.campus" />
            </FormRow>
            <FormRow inline>
              <FormCol field="custom.age" width="half">
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.age"
                />
                <!-- <ErrorLabel field="custom.age" /> -->
              </FormCol>
            </FormRow>
            <FormRow inline>
              <GenderPicker />
            </FormRow>   
            <FormRow inline>
              <FormCol field="custom.countryOfOrigin" width="half">
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.countryOfOrigin"
                />
                <!-- <ErrorLabel field="custom.age" /> -->
              </FormCol>
            </FormRow>
            
            
            <FormRow inline>
              <FormCol field="custom.dietaryRestrictions" width="full">
                <small>Vegetarian, Vegan, Gluten Free</small>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.dietaryRestrictions"
                />
                <!-- <ErrorLabel field="custom.age" /> -->
              </FormCol>
            </FormRow>
            
            

            <!-- <FormRow inline>
              <div>
                <FormLabel class="control-label">Dietary Restrictions</FormLabel>
                <small>Vegetarian, Vegan, Gluten Free</small>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.dietaryRestrictions"
                />
              </div>
            </FormRow> -->
            <FormRow inline>
              <FormCol field="custom.allergyInformation" width="full">
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.allergyInformation"
                />
                <!-- <ErrorLabel field="custom.age" /> -->
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Emergency Contact">
            <FormRow inline>
              <FormCol field="custom.emergencyContactName" width="full">
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.emergencyContactName"
                />
              </FormCol>
            </FormRow>
            
            <FormRow inline>
              <FormCol field="custom.emergencyContactPhone" width="full">
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.emergencyContactPhone"
                />
              </FormCol>
            </FormRow>
        
          </FormSection>
          <FormSection title="Additional Info">
										<FormRow>
												<FormLabel class="control-label">
													Comments or Questions:
											</FormLabel>
										</FormRow>									
										<FormRow>
											<FormInput type="textarea" class="width-half" field="custom.Notes"/>                      
										</FormRow> 
                    
            
            <FormRow inline>
              <div>
                <FormLabel class="control-label">Would you like to participate in leading davening and/or reading from the Torah and/or sharing a Dvar Torah at a meal?</FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.wouldYouParticipate"
                />
              </div>
            </FormRow>
            <FormRow inline>
              <div>
                <FormLabel class="control-label">Would you like to be involved with planning a mini program for the Shabbaton?</FormLabel>
                <FormInput
                  type="text"
                  class="width-full"
                  field="custom.wouldYouBeInvolved"
                />
              </div>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info:">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <!-- Conditionally render AmountSelectorList based on subsidy param -->
            <AmountSelectorList v-if="hasSubsidy" />
            <AmountSelectorList v-else :nocustom="true" />
            <ErrorLabel field="amount" />
          </FormSection>          
          <FormSection title="" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false"/>
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Submit"/>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue"
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  setup(props) {
    const { getValue, setValue, form } = usePaymentForm();

    const currency = ref(form.value.currency);
    const hasSubsidy = ref(false)

    setValue('gateway','SensepassCardknoxOUSpec')
    setValue('description', 'JLIC Israel Inter-Community Shabbaton')

    watch(() => getValue('currency'), () => {
      if (getValue('currency') == 'ILS') {
        setValue('gateway','SensepassCardcomPrograms')
      } else{
        setValue('gateway','SensepassCardknoxOUSpec')
      }
    });

    onMounted(() => {
      const params = queryParams()
      hasSubsidy.value = params.subsidy !== undefined && params.subsidy !== null && params.subsidy !== ''
    })

    return {
      form,
      currency,
      getValue,
      setValue,
      hasSubsidy
    }
  },
})
</script>

<style scoped lang="scss">
.form-container.jlic-israel-shabbaton-form{
     max-width: 800px;
    margin: 50px auto 50px;
    background-color: #f1f1f1;
    padding: 20px;
        @media only screen and (min-width: 720px) {
     max-width: 800px;
    margin: 50px auto 50px;
    background-color: #f1f1f1;
    padding: 20px;
        }
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
::v-deep .styled-radio-container.styled-radio-container--ou-donation.row {
      flex-flow: column;
      .amount-row{
        min-width: 100%;
        max-width: 100%;
      }
    label {
    background: #aaa;
    color: white;
    width: 100%;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #999;
    flex-flow: column;
    justify-content: center;
      &:hover {
        background: #999;
      }
    }
    .label-amount{
    min-width: 10px;
    max-width: 100%;
    font-weight: 600;
    padding:5px 0px 1px 10px;
    align-items: center;
    justify-content: center;
    height: 100%;
    display: flex;
    border-right: none;
      background: inherit;
    font-size: 20px;
    line-height: 1.4;
    }
input[type=radio]:checked + label .label-amount{
      background: #bf1b31;
    border-color: #bf1b31;
}
    input[type="radio"]:checked + label {
      background: #bf1b31;
    }
    .label-description {
    font-weight: 600;
    text-align: center;
    justify-content: center;
    padding: 1px 10px 10px;
    align-items: center;
    height: 100%;
    display: flex;
    font-size: 16px;
    line-height: 1.4;
        background: inherit;
    border: none;
}

.amount_other__wrapper.amount-row{
      max-width: 400px !important;
    min-width: 400px;
    margin-left: auto;
    margin-right: auto;
}
.amount_other__wrapper:before{
  padding: 15px 8px;
    border-right: 1px solid #ddd;
    height: 100%;
    background: #aaa;
    color: white;
    text-align: center;
    top: 0px;
    left: 0;
    width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
}
#amount_other{
  height: 44px;
    flex: 1;
    padding: 0px 0px 0px 71px;
    max-width: 100%;
}
input#amount_other:focus {
    background: white !important;
}
  }

.control-label {
  font-size: 14px;
  color: #222;
}

::v-deep  h2{
    color: #f23207;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 28.8px;
    border-bottom: 1px solid #ccc;
    padding: 0 0px 8px 0;
}
::v-deep  .control-label{
  max-width: 100%;
}
</style>

